<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { Head } from '@inertiajs/inertia-vue3'
import { onMounted, onUnmounted } from 'vue'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  myvalue: Array,
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})

onUnmounted(() => {})
</script>

<template>
  <div>
    <Head title="お問い合わせありがとうございました" />
    <div class="contact bg-white py-[110px] lg:py-[200px]">
      <h2 class="font-rift font-bold text-black text-[72px] lg:text-[110px] tracking-[0.015em] text-center">
        Thank you
        <span class="block mt-3 text-[16px] lg:text-[22px] font-bold">お問い合わせありがとうございました</span>
      </h2>
      <div class="mt-10 w-[90%] md:w-[65%] mx-auto text-center text-[3.8vw] md:text-sm leading-10 md:leading-6">
        <p class="mt-6">土日祝は休業となっておりますため、連休などは対応が遅くなる場合がございます。</p>
        <p class="mt-6">送信いただきましたメールの回答は、迅速な対応を心がけておりますが、一週間を過ぎましても、返信メールが届かない場合には、メールアドレスに間違いがある可能性がございます。恐れ入りますが、入力していただいたメールアドレスをご確認の上、再度送信をお願いいたします。</p>
        <p class="mt-6">また、迷惑メールに振り分けされることもございます。恐れ入りますが、迷惑メールフォルダもご確認いただけますようお願い申し上げます。</p>
        <p class="mt-6">ご質問を多数いただいている場合には、返信に時間がかかる場合がございます。 あらかじめご了承ください。</p>
      </div>
      <div class="mt-10 max-w-[270px] mx-auto">
        <ButtonRounded  text="お問い合わせトップへ戻る" url="/contact/" icon="arrow" />
      </div>
    </div>
  </div>
</template>
